import axios from "axios";
import utils from "@/utils";
import storeutils from "@/stores/utils";

export default {
    install(Vue) {
        Vue.prototype.$utils = utils;
        Vue.prototype.$storeutils = storeutils;
        Vue.prototype.$axios = axios;
    },
};
